import React from 'react';
import { Phone, Users } from 'lucide-react';
import { howItWorksSteps } from '../data/mock';

const StepCard = ({ step, index }) => {
  const getIcon = () => {
    switch (index) {
      case 0:
        return (
          <div className="grid grid-cols-2 gap-2">
            <div className="w-8 h-8 bg-white rounded-lg"></div>
            <div className="w-8 h-8 bg-white rounded-lg"></div>
            <div className="w-8 h-8 bg-white rounded-lg"></div>
            <div className="w-8 h-8 bg-white rounded-lg"></div>
          </div>
        );
      case 1:
        return (
          <div className="flex items-center gap-3">
            <div className="w-20 h-3 bg-gray-600 rounded-full"></div>
            <div className="w-12 h-12 rounded-lg border-2 border-dashed border-gray-500 flex items-center justify-center">
              <span className="text-gray-400 text-2xl">+</span>
            </div>
          </div>
        );
      case 2:
        return (
          <div className="space-y-2">
            <div className="w-32 h-2 bg-gray-600 rounded-full"></div>
            <div className="w-24 h-2 bg-gray-600 rounded-full"></div>
            <div className="w-28 h-2 bg-gray-600 rounded-full"></div>
            <div className="w-20 h-2 bg-gray-600 rounded-full"></div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="relative group">
      {/* Number Badge */}
      <div className="absolute -top-4 left-1/2 -translate-x-1/2 z-20">
        <div className="w-8 h-8 rounded-full bg-[#2a2a2f] border border-white/20 flex items-center justify-center text-white text-sm font-medium">
          {step.number}
        </div>
      </div>

      {/* Card */}
      <div className={`relative h-80 rounded-3xl overflow-hidden transition-all duration-500 group-hover:scale-[1.02] ${
        index === 1 ? 'bg-gradient-to-br from-[#1a1a1f] via-[#1a1a1f] to-purple-900/30' : 'bg-[#1a1a1f]'
      } border border-white/5`}>
        {/* Card Inner Content */}
        <div className="h-48 flex items-center justify-center p-8">
          {getIcon()}
        </div>

        {/* Card Footer */}
        <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-[#1a1a1f] to-transparent">
          <h3 className="text-white text-xl font-medium mb-2">{step.title}</h3>
          <p className="text-gray-400 text-sm leading-relaxed">{step.description}</p>
        </div>

        {/* Hover gradient */}
        <div className="absolute inset-0 bg-gradient-to-t from-purple-900/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
      </div>
    </div>
  );
};

const HowItWorks = ({ onOpenModal }) => {
  return (
    <section className="bg-[#0a0a0b] py-24 px-6" id="how-it-works">
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-[#1a1a1f] border border-white/10 text-sm text-gray-300 mb-6">
            How it works
          </div>
          <h2 className="text-4xl md:text-5xl text-white font-normal mb-4">
            Getting started is <span className="italic font-light">simple.</span>
          </h2>
          <p className="text-gray-400 text-lg">
            A simple, three-step process to organize your tech team
          </p>
        </div>

        {/* Steps Grid */}
        <div className="grid md:grid-cols-3 gap-6 mb-12">
          {howItWorksSteps.map((step, index) => (
            <StepCard key={step.id} step={step} index={index} />
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <button
            onClick={onOpenModal}
            className="inline-flex items-center gap-2 bg-[#7c3aed] hover:bg-[#6d28d9] text-white px-8 py-3.5 rounded-full text-base font-medium transition-all duration-300 hover:scale-105 shadow-lg shadow-purple-500/20"
          >
            <Phone className="w-5 h-5" />
            Book a call
          </button>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
